import { render, staticRenderFns } from "./importWord.vue?vue&type=template&id=3856e492&scoped=true"
import script from "./importWord.vue?vue&type=script&lang=js"
export * from "./importWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856e492",
  null
  
)

export default component.exports